<template>
  <div class="liu pos-manage" v-wechat-title="'填写银行卡信息'">
    <!-- 显示信息 -->
    <div class="form mt-15">
      <div class="row">
        <div class="item">
          <div class="label">
            <span>卡类型</span>
          </div>
          <div class="content">
            <span>{{ cardBankName }} {{ cardTypeCn }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <div class="label">
            <span>卡号</span>
          </div>
          <div class="content">
            <span>{{ cardNumber }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 填写信息 -->
    <div class="form mt-15">
      <div class="row">
        <div class="item">
          <div class="label">
            <span>姓名</span>
          </div>
          <div class="content">
            <input type="text" v-model="cardIdName" maxlength="15" placeholder="请输入持卡人本人姓名">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <div class="label">
            <span>证件号</span>
          </div>
          <div class="content">
            <input type="text" v-model="cardIdNumber" maxlength="20" placeholder="请输入本人身份证号"
              @keyup="onCardIdNumberInput">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <div class="label">
            <span>手机号</span>
          </div>
          <div class="content">
            <input type="text" v-model="cardMobile" maxlength="13" placeholder="请输入预留手机号" @keyup="onCardMobileInput">
          </div>
        </div>
      </div>
    </div>
    <!-- 手持身份证照片 -->
    <div class="form mt-15" v-if="cardNeedAudit">
      <div class="row">
        <div class="item">
          <div class="label long">
            <span>手持身份证照片</span>
          </div>
          <div class="content">
            <div class="picture" @click="$refs.camera.imgClick('unlockIdCard')">
              <svg-icon v-if="!cardIdCardImg" icon-class="camera_comm" class-name="svg" />
              <img v-else :src="cardIdCardImg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手持银行卡照片 -->
    <div class="form mt-15" v-if="cardNeedAudit">
      <div class="row">
        <div class="item">
          <div class="label long">
            <span>手持银行卡照片</span>
          </div>
          <div class="content">
            <div class="picture" @click="$refs.camera.imgClick('unlockBankCard')">
              <svg-icon v-if="!cardBankCardImg" icon-class="camera_comm" class-name="svg" />
              <img v-else :src="cardBankCardImg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn">
      <mt-button type="primary" size="large" @click="onUnlockSubmitClick">
        解锁
      </mt-button>
    </div>
    <!-- 相机组件 -->
    <camera ref="camera" @getImgInfo="getCameraImgInfo" />
  </div>
</template>

<script>
/* global wx */

import { upLoadImg } from '@/utils/utils';
import { GetBlackBankCardById, UnlockingBankCard } from '@/api/weChat';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { controlIdCardInput, controlMobileInput } from '@/utils/format';
import { validateEmpty, validateIdCard, validateMobile } from '@/utils/validate';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import SvgIcon from '@/components/SvgIcon';
import camera from '@/components/camera';

export default {
  name: 'UnlockEdit',
  components: { SvgIcon, camera },
  data() {
    return {
      title: '',
      cardId: '',
      cardBankName: '',
      cardTypeCn: '',
      cardNumber: '',
      cardIdName: '',
      cardIdNumber: '',
      cardMobile: '',
      cardNeedAudit: false,
      cardIdCardImg: '',
      cardBankCardImg: '',
      mobile: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.title = this.$route.query.title;
      this.cardId = this.$route.query.id;
      this.mobile = this.$route.query.mobile;
      this.getBlackBankCardById();
    });
  },
  methods: {
    // 相机组件处理返回的图片信息的方法
    getCameraImgInfo(info) {
      upLoadImg(info.blob, info.base64, info.type, this.mobile, res => {
        switch (info.type) {
          case 'unlockIdCard':
            this.cardIdCardImg = res.data;
            break;
          case 'unlockBankCard':
            this.cardBankCardImg = res.data;
            break;
        }
      });
    },
    // 验证提交接口数据合法性
    validateSubmitData(callback = null) {
      const cardIdNameErr = validateEmpty(this.cardIdName);
      const cardIdNumberErr = validateIdCard(this.cardIdNumber);
      const cardMobileErr = validateMobile(this.cardMobile);
      const cardIdCardImgErr = validateEmpty(this.cardIdCardImg);
      const cardBankCardImgErr = validateEmpty(this.cardBankCardImg);

      let errResult = null;
      if (this.cardNeedAudit) {
        errResult = !cardIdNameErr && !cardIdNumberErr && !cardMobileErr && !cardIdCardImgErr && !cardBankCardImgErr;
        if (errResult) {
          callback && callback();
        } else {
          if (cardIdNameErr) {
            CusToast('姓名不能为空');
            return;
          }
          if (cardIdNumberErr === 1) {
            CusToast('证件号不能为空');
            return;
          }
          if (cardIdNumberErr === 2) {
            CusToast('证件号格式不正确');
            return;
          }
          if (cardMobileErr === 1) {
            CusToast('手机号不能为空');
            return;
          }
          if (cardMobileErr === 2) {
            CusToast('手机号格式不正确');
            return;
          }
          if (cardIdCardImgErr) {
            CusToast('必须上传手持身份证照片');
            return;
          }
          if (cardBankCardImgErr) {
            CusToast('必须上传手持银行卡照片');
            return;
          }
        }
      } else {
        errResult = !cardIdNameErr && !cardIdNumberErr && !cardMobileErr;
        if (errResult) {
          callback && callback();
        } else {
          if (cardIdNameErr) {
            CusToast('姓名不能为空');
            return;
          }
          if (cardIdNumberErr === 1) {
            CusToast('证件号不能为空');
            return;
          }
          if (cardIdNumberErr === 2) {
            CusToast('证件号格式不正确');
            return;
          }
          if (cardMobileErr === 1) {
            CusToast('手机号不能为空');
            return;
          }
          if (cardMobileErr === 2) {
            CusToast('手机号格式不正确');
            return;
          }
        }
      }
    },
    // 证件号输入事件
    onCardIdNumberInput() {
      this.cardIdNumber = controlIdCardInput(this.cardIdNumber);
    },
    // 手机号输入事件
    onCardMobileInput() {
      this.cardMobile = controlMobileInput(this.cardMobile);
    },
    // 解锁按钮点击事件
    onUnlockSubmitClick() {
      this.validateSubmitData(() => {
        this.unlockingBankCard(() => {
          // 由于通过wx.miniProgram.navigateBack返回后，不会触发小程序页面的onShow事件
          // 所以直接返回我的页面
          wx.miniProgram.navigateBack({ delta: 3 });
        });
      });
    },
    // 调用接口，获取银行卡黑名单信息
    getBlackBankCardById(callback = null) {
      CusLoadingOpen();
      GetBlackBankCardById({ blackBankCardId: this.cardId })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.cardBankName = res.data.bankAllName;
              this.cardTypeCn = res.data.cardType === 1 ? '储蓄卡' : '信用卡';
              this.cardNumber = res.data.cardNum;
              this.cardNeedAudit = Boolean(res.data.isNeedAudit);
              this.callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，解锁银行卡
    unlockingBankCard(callback = null) {
      CusLoadingOpen();
      const data = {
        blackBankCardId: this.cardId,
        name: this.cardIdName,
        idCardNum: this.cardIdNumber.replace(/\s/gi, ''),
        phone: this.cardMobile.replace(/\s/gi, ''),
        frontIDCardUrl: this.cardIdCardImg,
        negativeIdCardUrl: this.cardBankCardImg,
      };
      UnlockingBankCard(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusAlert(res.msg, () => callback && callback());
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  .row {
    .item {
      .label {
        width: 4rem;

        &.long {
          width: 6rem;
        }
      }
    }
  }
}
</style>
